import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorHandler } from '../services/error-handler';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandler);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const contentType = error.headers?.get('content-type') ?? '';

      if (typeof error.error === 'string' && contentType.startsWith('application/json')) {
        try {
          const parsed = JSON.parse(error.error);
          error = new HttpErrorResponse({
            ...error,
            error: parsed,
            url: error.url ?? undefined,
          });
        } catch {}
      }

      return throwError(() => errorHandler.handleHttpError(error));
    }),
  );
};
